module.exports = __webpack_public_path__ + "static/media/the-promised-land-mobile.b2775833.jpg";